import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { orderEscalationBody, AutoNotesTypes } from './notes.constants';
import { HttpClient } from '@angular/common/http';
import { AutoNotesService } from './auto-notes.service';

@Injectable({
  providedIn: 'root'
})
export class OrderEscalationService {

  constructor(private httpClient: HttpClient, private autoNotesService: AutoNotesService) { }

  escalationNote(noteData: orderEscalationBody): void {
    this.httpClient.post(`${environment.reporting.baseUrl}/order-escalation`, noteData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('acmToken')}`,
        }
      }).subscribe(() => {
      this.autoNotesService.generateNote({autoNotesType: AutoNotesTypes.escalated, orderId: noteData.order_id, reason: noteData.reason})
    });
  }

  getEscalationNote(orderId: string): any {
    return this.httpClient.get(`${environment.reporting.baseUrl}/order-escalation/${orderId}?OrderId=${orderId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('acmToken')}`,
        }
      })
  }
}
